export default __webpack_public_path__ + "static/media/Primary-PointOnImage.92c739fd.svg";